module.exports = __webpack_public_path__ + "static/tuebingen-logo-53669a59edd440956d4eb7ad6a78ccd4.jpg";